import * as Headless from '@headlessui/react';
import { ReactNode } from 'react';
import RequiredIndicator from '@/components/RequiredIndicator';
import Text from '@/components/Text';
import cn from '@/utils/cn';
import isString from '@/utils/typeGuards/isString';

type TProps = {
  addon?: ReactNode;
  className?: string;
  children: ReactNode;
  shouldLocalize?: boolean;
  visuallyHidden?: boolean;
  withRequiredIndicator?: boolean;
} & Omit<Headless.LabelProps, 'as' | 'className'>;

export const Label = ({
  addon,
  className,
  children,
  shouldLocalize = true,
  visuallyHidden = false,
  withRequiredIndicator,
  ...props
}: TProps) => {
  const shouldLocalizeText = shouldLocalize && isString(children);
  const hasAddon = Boolean(addon);
  const text = (
    <>
      {shouldLocalizeText ? <Text>{children}</Text> : children}
      {withRequiredIndicator ? <RequiredIndicator /> : null}
    </>
  );

  return (
    <Headless.Label
      data-slot="label"
      {...props}
      className={cn(
        'flex select-none items-baseline font-medium text-base text-grayscale-darkGray data-disabled:opacity-50',
        visuallyHidden && !hasAddon && 'sr-only',
        className
      )}
    >
      {visuallyHidden && hasAddon ? (
        <span className="sr-only">{text}</span>
      ) : (
        text
      )}
      {addon}
    </Headless.Label>
  );
};
